export const SUPPORTED_EVENTS = new Set<string>(['INTERACTION']);
